import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { Line } from 'react-chartjs-2';
import { Chart } from 'chart.js';
import { ChartJSOrUndefined } from 'react-chartjs-2/dist/types';
import { getAdImpressionsChartOptions, getAdImpressionsChartPlugins } from './utils';

interface AdImpressionsChartProps {
  chartRef: React.RefObject<ChartJSOrUndefined<'line'>>;
  handleChartClick: (chart: Chart, event: MouseEvent) => void;
  clickedIndex: number | null;
  plotData: any;
}

const AdImpressionsChart: React.FC<AdImpressionsChartProps> = ({
  chartRef,
  handleChartClick,
  clickedIndex,
  plotData,
}) => {
  const labels = plotData?.map((item: { week_start: any }) => item.week_start);

  useEffect(() => {
    if (chartRef.current) {
      // Update plugins when clickedIndex or data changes
      Chart.unregister(getAdImpressionsChartPlugins(null));
      Chart.register(getAdImpressionsChartPlugins(clickedIndex));
      return () => {
        Chart.unregister(getAdImpressionsChartPlugins(null));
      };
    }
  }, [clickedIndex, plotData]);

  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Ad Impressions',
        data: plotData?.map((item: { index_value: any }) => item.index_value),
        fill: false,
        borderColor: '#2F736E',
        borderWidth: 2,
        tension: 0,
        pointRadius: 0,
        pointHoverRadius: 4,
        pointHitRadius: 4,
        pointBorderWidth: 2,
        pointHoverBorderWidth: 2,
        pointBackgroundColor: '#FFF',
        pointHoverBackgroundColor: '#FFF',
      },
    ],
  };

  const handleClick = (event: React.MouseEvent<HTMLCanvasElement>) => {
    if (chartRef.current) {
      handleChartClick(chartRef.current, event.nativeEvent);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: 'fit-content',
        backgroundColor: 'white',
        borderRadius: '12px',
        paddingX: '0.75rem',
        marginTop: '2.25rem',
        minHeight: '542px',
      }}
    >
      {plotData?.length > 0 ? (
        <Line
          data={data}
          options={getAdImpressionsChartOptions(labels)}
          plugins={getAdImpressionsChartPlugins(clickedIndex)}
          ref={chartRef}
          onClick={handleClick}
        />
      ) : (
        <Box
          sx={{
            height: '100%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
          }}
        >
          No data
        </Box>
      )}
    </Box>
  );
};

export default AdImpressionsChart;
